import $ from 'jquery';
import { PopoverView, contents } from '@bingads-webui/popover';
import { a11yPlugin } from '@bingads-webui/projection-grid-a11y';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import projectionGrid from 'projection-grid';

class PopoverTableView extends DeterministicWrapperView {
  viewFactory({
    columns,
    data,
    i18n,
  }) {
    const config = {
      dataSource: {
        type: 'memory',
        data,
      },
      columns,
      tableClasses: ['table', 'table-bordered'],
      plugins: {
        a11y: { i18n },
      },
    };

    this.grid = projectionGrid
      .factory({
        vnext: true,
      })
      .use(a11yPlugin)
      .create(config);

    return this.grid.gridView;
  }
}

export function showPopoverTableView(target, containerClassName, viewTitle, columns, data, i18n) {
  const targetRect = target.getBoundingClientRect();
  new PopoverView({
    target: $(target),
    position: {
      isAbsolute: true,
      left: targetRect.right + window.scrollX,
      top: targetRect.top + window.scrollY,
    },
    containerClassName,
  }).setContent(new contents.TitledContent()
    .setTitle(viewTitle)
    .setBody(new PopoverTableView({
      columns,
      data,
      i18n,
    })));
}
